<template>
  <div class="changePricePage">
    <div class="pirceInfo">
      <Form layout="inline">
        <FormItem label="实际费用" required>
          <InputNumber :precision="2" v-model="realPrice"></InputNumber>
        </FormItem>
        <Icon type="question-circle" style="font-size:28px; margin-top:5px" @click="changePriceRecord"/>
      </Form>
      <Form>
        <FormItem label="修改原因" required>
          <TextArea v-model="changeReason"/>
        </FormItem>
      </Form>
    </div>
    <div class="footer">
      <div>
        <Button @click="closeChangePrice">取消</Button>
        <Button type="primary" @click="handleSureChange">确定</Button>
      </div>
    </div>
    <!-- 查看修改记录 -->
    <Modal v-model="showChangeRecordFlag"  v-if="showChangeRecordFlag" title="修改记录" width="40%">
      <Table size="small" :columns="columns" :dataSource="tableData" border rowKey="id" :pagination="false"></Table>
      <div slot="footer">
        <Button size="large" @click="closeModal">返回</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { Button, Form, InputNumber, Input, Icon, Modal, Table } from 'ant-design-vue'
import { getChangePriceRecord } from '../../api/onlineCheckin'
import { toast } from '../../libs/utils'
export default {
  props: {
    userPrice: {
      type: Number,
      default: 0
    },
    changeType: {
      type: String,
      default: ''
    },
    checkOrderId: {
      type: Number,
      default: 0
    }
  },
  components: {
    Button,
    Form,
    FormItem: Form.Item,
    InputNumber,
    TextArea: Input.TextArea,
    Icon,
    Modal,
    Table
  },
  mounted () {
    this.realPrice = this.userPrice
  },
  data () {
    return {
      realPrice: 0,
      changeReason: '',
      columns: [
        { title: '序号', customRender: (text, record, index) => `${index + 1}` },
        { title: '修改时间', dataIndex: 'updated_date' },
        { title: '修改前金额', dataIndex: 'old_value' },
        { title: '修改后金额', dataIndex: 'new_value' },
        { title: '修改原因', dataIndex: 'remark' },
        { title: '操作人', dataIndex: 'creator' }
      ],
      tableData: [],
      showChangeRecordFlag: false,
      pageNumber: 1,
      pageSize: 20
    }
  },
  methods: {
    closeChangePrice () {
      this.$emit('closeChangePrice')
    },
    handleSureChange () {
      if (!this.realPrice.toString()) return toast({ title: '提示', type: 'warning', msg: '请填写修改金额' })
      if (!this.changeReason) return toast({ title: '提示', type: 'warning', msg: '请填写修改原因' })

      let params = {
        changePrice: this.realPrice,
        changeReason: this.changeReason
      }
      this.$emit('handleSureChange', params)
    },
    async changePriceRecord () {
      this.showChangeRecordFlag = true
      if (!this.checkOrderId) return false
      let params = {
        orderCheckId: this.checkOrderId,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize
      }
      if (this.changeType == 'addCheck') params.recordChangeLogTypeEnum = 'CHECK_ORDER_PRICE'
      if (this.changeType == 'extraCost') params.recordChangeLogTypeEnum = 'ADDITIONAL_PRICE'
      let data = await getChangePriceRecord(params)
      if (data) this.tableData = data.results
    },
    closeModal () {
      this.showChangeRecordFlag = false
    }
  }
}
</script>

<style lang="less">
@import url('../../style/index.less');
.changePricePage{
  .pirceInfo{
    .ant-input-number-handler-wrap{
      display: none;
    }
  }
  .footer{
    .modalFooter();
  }
}
</style>